"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Refills = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const table_1 = require("../../components/web-view/table");
const button_1 = require("primereact/button");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const react_i18next_1 = require("react-i18next");
const refills_module_scss_1 = __importDefault(require("./refills.module.scss"));
const getAll_1 = require("../../modules/refills/app/getAll");
const getBasicInfo_1 = require("../../modules/machine/app/getBasicInfo");
const react_router_dom_1 = require("react-router-dom");
const FiltersComponent_1 = require("../../components/filter/FiltersComponent");
const usePagination_1 = require("../../hooks/pagination/usePagination");
const ApiRefillRepo_1 = require("../../modules/refills/infra/ApiRefillRepo");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const RefillList_1 = require("./mobile/RefillList");
const datesHelpers_1 = require("../../common/utils/datesHelpers");
const FilterContext_1 = require("../../context/filters/FilterContext");
const ApiMachineRepo_1 = require("../../modules/machine/infra/ApiMachineRepo");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const repo = (0, ApiRefillRepo_1.createApiRefillRepo)();
const machineRepo = (0, ApiMachineRepo_1.createApiMachineRepo)();
const Refills = () => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { filters, setFilters } = (0, FilterContext_1.useFilters)();
    const [globalFilterValue, setGlobalFilterValue] = (0, react_1.useState)(filters.globalFilterValue || '');
    const [error, setError] = (0, react_1.useState)(null);
    const localStorageFilters = JSON.parse(localStorage.getItem('filters') || '{}');
    const [dateFilter, setDateFilter] = (0, react_1.useState)(localStorageFilters.startDate && localStorageFilters.endDate
        ? [
            new Date(localStorageFilters.startDate),
            new Date(localStorageFilters.endDate),
        ]
        : datesHelpers_1.getDefaultDateRangeArray);
    const [machineIds, setMachineIds] = (0, react_1.useState)([]);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(() => {
        const storedPage = localStorage.getItem('currentPage');
        return storedPage ? parseInt(storedPage, 10) : 1;
    });
    const fetchRefills = (0, react_1.useCallback)(async (page = 1, pageSize = 10) => {
        try {
            const fromDate = filters.startDate
                ? Math.floor(new Date(filters.startDate).getTime() / 1000).toString()
                : undefined;
            const toDate = filters.endDate
                ? Math.floor(new Date(filters.endDate).getTime() / 1000).toString()
                : undefined;
            return await (0, getAll_1.getAll)(repo, page, pageSize, globalFilterValue, fromDate, toDate);
        }
        catch (err) {
            console.error('Fetch error:', err);
            setError('Error al cargar los datos');
            throw err;
        }
    }, [globalFilterValue, filters.startDate, filters.endDate]);
    const { data, loading, fetchData } = (0, usePagination_1.usePagination)(currentPage, 10, fetchRefills, (item) => item.messageId);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page.toString());
        fetchData(page, 10);
    };
    const resetPageAndFetch = (newFilters) => {
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
        setGlobalFilterValue(newFilters.globalFilterValue);
        setFilters(newFilters);
    };
    // Modificar eventos de filtro:
    const onGlobalFilterChange = (e) => {
        const newFilters = {
            globalFilterValue: e,
            startDate: filters.startDate,
            endDate: filters.endDate,
            clubId: filters.clubId,
        };
        resetPageAndFetch(newFilters);
    };
    (0, react_1.useEffect)(() => {
        if (filters.startDate && filters.endDate) {
            setDateFilter([new Date(filters.startDate), new Date(filters.endDate)]);
        }
    }, [filters]);
    (0, react_1.useEffect)(() => {
        const getMachineInfo = async () => {
            await (0, getBasicInfo_1.getBasicInfo)(machineRepo).then((res) => {
                setMachineIds(res.map((machine) => machine.micronMachineId));
            });
        };
        getMachineInfo();
    }, []);
    (0, react_1.useEffect)(() => {
        if (filters.startDate && filters.endDate) {
            fetchData(currentPage, 10, false, globalFilterValue, [], [], filters.startDate, filters.endDate);
        }
    }, [filters, currentPage, globalFilterValue]);
    const columns = [
        {
            field: 'createTime',
            header: 'date',
            renderFunc: (refill) => {
                if (!refill.createTime)
                    return '';
                const localTime = dayjs_1.default
                    .unix(Number(refill.createTime))
                    .tz(dayjs_1.default.tz.guess())
                    .format('DD-MM-YYYY HH:mm:ss');
                return ((0, jsx_runtime_1.jsx)("span", { className: "font-semibold", children: localTime.toLocaleLowerCase() }));
            },
        },
        {
            field: 'micronMachineId',
            header: 'machineId',
            renderFunc: (refill) => {
                if (!refill.micronMachineId)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { children: refill.micronMachineId });
            },
        },
        {
            field: 'username',
            header: 'user',
            renderFunc: (refill) => {
                if (!refill.username)
                    return '';
                return ((0, jsx_runtime_1.jsx)("span", { style: { textTransform: 'capitalize' }, children: refill.username }));
            },
        },
        {
            field: 'status',
            header: 'status',
            renderFunc: (refill) => {
                if (!refill.status)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { className: "font-semibold", children: t(refill.status) });
            },
        },
    ];
    const handlerGotoDetail = (refill) => {
        navigate(`/refills/${refill.messageId}`);
    };
    const handlerDateFilter = (dates) => {
        const newFilters = {
            globalFilterValue,
            startDate: dates?.[0]?.toISOString() || '',
            endDate: dates?.[1]?.toISOString() || '',
            clubId: null,
        };
        resetPageAndFetch(newFilters);
    };
    const onMachineIdChange = (machineId) => {
        const newFilters = {
            globalFilterValue: machineId,
            startDate: filters.startDate,
            endDate: filters.endDate,
            clubId: filters.clubId,
        };
        resetPageAndFetch(newFilters);
    };
    const renderActionButtons = (refill) => ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center gap-2", children: (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-eye", className: "p-button-rounded p-button-info p-button-outlined", onClick: () => handlerGotoDetail(refill) }) }));
    const resetPageToFirst = () => {
        setCurrentPage(1);
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: isMobile ? ((0, jsx_runtime_1.jsx)(RefillList_1.RefillList, { refills: data.items, globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, fetchData: fetchData, loading: loading, pagination: data.pagination, handlerDateFilter: handlerDateFilter, dateFilter: dateFilter, resetPageToFirst: resetPageToFirst, ids: machineIds, onMachineIdChange: onMachineIdChange })) : ((0, jsx_runtime_1.jsx)("div", { className: refills_module_scss_1.default.container, children: (0, jsx_runtime_1.jsx)(table_1.AppTable, { columns: columns, actions: renderActionButtons, fetchData: fetchData, data: data, loading: loading, getKey: (item) => item.micronMachineId, globalFilterFields: ['machineId'], headerContent: (0, jsx_runtime_1.jsx)("div", { className: 'flex items-center gap-2', children: (0, jsx_runtime_1.jsx)("h2", { children: t('refillList') }) }), currentPage: currentPage, handleCurrentPage: handlePageChange, filtersComponent: (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, handlerDateFilter: handlerDateFilter, onMachineIdChange: onMachineIdChange, machineId: globalFilterValue ?? '', ids: machineIds, resetPageToFirst: () => setCurrentPage(1) }) }, JSON.stringify(data.pagination)) })) }));
};
exports.Refills = Refills;
